<template>
  <div class="layout-container" >

    <div class="sidebar" :class="{ collapsed: collapsed }" >
      <div class="logo" @mousedown="down" @mouseup="up">
        <div class="logo-icon">管</div>
        <h2 v-if="!collapsed">智管家</h2>
      </div>
      <div 
        v-for="(item, index) in menuItems" 
        :key="index"
        class="menu-item"
        :class="{ active: activeMenu === item.path }"
        @click="navigateTo(item.path)"
        v-if="!item.meta?.platform_type || item.meta.platform_type.includes(userInfo.platform_type)"
      >
        <i :class="item.meta.icon"></i>


        <span v-if="!collapsed">{{ item.meta.title }}</span>
      </div>
      <div class="expiry-info" >

        <el-tooltip class="item" v-if="collapsed" effect="dark" :content="userInfo.vip_time_text+' 到期'" placement="left">
          <div class="expiry-icon" >
            <i class="el-icon-time"></i>
          </div>
        </el-tooltip>

        <div class="expiry-icon" v-else>
          <i class="el-icon-time"></i>
        </div>
        <div class="expiry-content" v-if="!collapsed">
          <div class="expiry-label">卡密到期</div>
          <div class="expiry-date">{{ userInfo.vip_time_text }}</div>
        </div>
      </div>
    </div>
    <div class="main-container" >
      <div class="header" @mousedown="down" @mouseup="up">
        <div class="header-left">
          <i class="el-icon-s-fold collapse-btn" :class="[{acitve:!collapsed}]" @click="collapsed = !collapsed"></i>
          <span class="page-title">{{ currentTitle }}</span>
        </div>
        <div class="header-right">
          <div class="user-info-wrapper">
            <div class="user-avatar" @click="showUserMenu = !showUserMenu">
              管
            </div>
            <div class="user-details" @click="showUserMenu = !showUserMenu">
              <div class="user-name">{{ userInfo?.user }}</div>
              <div class="user-role">会员用户</div>
            </div>
            <div class="user-dropdown" v-if="showUserMenu" @click.self="showUserMenu = false">
              <div class="dropdown-item" @click="openPasswordModal">
                <i class="el-icon-lock"></i>
                修改密码
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-item" @click="openRechargeModal">
                <i class="el-icon-coin"></i>
                卡密充值
              </div>
              <div class="dropdown-divider"></div>
              <div class="dropdown-item" @click="logout">
                <i class="el-icon-switch-button"></i>
                退出登录
              </div>
            </div>
          </div>
          <button class="window-btn" @click="eSend('window','minimize')">
            <i class="el-icon-minus"></i>
          </button>
          <button class="window-btn close" @click="eSend('window','close')">
            <i class="el-icon-close"></i>
          </button>
        </div>
      </div>
      <div class="main-content">
        <keep-alive>
          <router-view />
        </keep-alive>
      </div>
    </div>

    <!-- 卡密充值弹窗 -->
    <el-dialog
      title="卡密充值"
      :visible.sync="showRechargeModal"
      width="420px"
      :close-on-click-modal="false"
      custom-class="recharge-dialog"
    >
      <div class="recharge-content">
        <div class="recharge-info">
          <div class="recharge-icon">
            <i class="el-icon-coin"></i>
          </div>
          <div class="recharge-text">
            <div class="recharge-title">请输入卡密进行充值</div>
            <div class="recharge-desc">当前到期时间：{{ userInfo.vip_time_text }}</div>
          </div>
        </div>
        <el-input
          v-model="cardKey"
          placeholder="请输入卡密"
          size="large"
          clearable
          @keyup.enter.native="handleRecharge"
        ></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showRechargeModal = false">取消</el-button>
        <el-button type="primary" @click="handleRecharge" :loading="recharging">
          立即充值
        </el-button>
      </span>
    </el-dialog>

    <!-- 修改密码弹窗 -->
    <el-dialog
      title="修改密码"
      :visible.sync="showPasswordModal"
      width="420px"
      :close-on-click-modal="false"
      custom-class="password-dialog"
    >
      <div class="password-content">
        <div class="password-info">
          <div class="password-icon">
            <i class="el-icon-lock"></i>
          </div>
          <div class="password-text">
            <div class="password-title">请输入新密码</div>
            <div class="password-desc">密码长度至少6位</div>
          </div>
        </div>
        <el-form :model="passwordForm" label-width="80px" size="large">
          <el-form-item label="原密码">
            <el-input
              v-model="passwordForm.oldPassword"
              type="password"
              placeholder="请输入原密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="新密码">
            <el-input
              v-model="passwordForm.newPassword"
              type="password"
              placeholder="请输入新密码"
              show-password
            ></el-input>
          </el-form-item>
          <el-form-item label="确认密码">
            <el-input
              v-model="passwordForm.confirmPassword"
              type="password"
              placeholder="请再次输入新密码"
              show-password
              @keyup.enter.native="handleUpdatePassword"
            ></el-input>
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="showPasswordModal = false">取消</el-button>
        <el-button type="primary" @click="handleUpdatePassword" :loading="updating">
          确认修改
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import http from "@/utils/http";

export default {
  name: 'Layout',
  inject:["getUser",'eSend','up','down'],
  data() {
    return {
      collapsed: false,
      showUserMenu: false,
      showRechargeModal: false,
      cardKey: '',
      recharging: false,
      showPasswordModal: false,
      passwordForm: {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      },
      updating: false,





    }
  },
  watch:{

    collapsed(){
      localStorage.setItem("collapsed",this.collapsed);

    }

  },
  created() {


    if(localStorage.getItem("collapsed")=='true'){
      this.collapsed=true;
    }else{
      this.collapsed=false;
    }


  },
  computed: {

    userInfo(){

      return this.$store.getters.userInfo || this.getUser();
    },
    activeMenu() {
      return this.$route.path
    },
    currentTitle() {
      return this.$route.meta.title || '智能场控'
    },
    menuItems() {
      const mainRoute = this.$router.options.routes.find(r => r.path === '/')
      if (!mainRoute || !mainRoute.children) {
        return []
      }
      return mainRoute.children
        .filter(route => route.meta && route.meta.title)
        .map(route => ({
          ...route,
          path: '/' + route.path
        }))
    }
  },
  methods: {


    navigateTo(path) {
      if (this.$route.path !== path) {
        this.$router.push(path).catch(err => {
          if (err.name !== 'NavigationDuplicated') {
            console.error(err)
          }
        })
      }
    },
    openPasswordModal() {
      this.showUserMenu = false
      this.passwordForm = {
        oldPassword: '',
        newPassword: '',
        confirmPassword: ''
      }
      this.showPasswordModal = true
    },
    async handleUpdatePassword() {
      // 验证输入
      if (!this.passwordForm.oldPassword.trim()) {
        this.$message.warning('请输入原密码')
        return
      }
      if (!this.passwordForm.newPassword.trim()) {
        this.$message.warning('请输入新密码')
        return
      }
      if (this.passwordForm.newPassword.length < 6) {
        this.$message.warning('新密码长度至少6位')
        return
      }
      if (this.passwordForm.newPassword !== this.passwordForm.confirmPassword) {
        this.$message.warning('两次输入的密码不一致')
        return
      }
      
      this.updating = true


      const res=await http.post("api/user/changePass",this.passwordForm);
      this.updating = false

      if(res.code==200){
        this.$message.success('密码修改成功！')
        this.passwordForm = {
          oldPassword: '',
          newPassword: '',
          confirmPassword: ''
        }
        this.showPasswordModal = false

        return;
      }

      this.$message.error('原密码错误')

    },
    openRechargeModal() {
      this.showUserMenu = false
      this.cardKey = ''
      this.showRechargeModal = true
    },
    async handleRecharge() {
      if (!this.cardKey.trim()) {
        this.$message.warning('请输入卡密')
        return
      }
      
      this.recharging = true

      const res=await http.post("api/user/recharge",{key:this.cardKey});
      this.recharging = false

      if(res.code==200){
        this.$message.success(res.msg)

        this.showRechargeModal = false
        this.cardKey = ''
        this.getUser();
        return;
      }
      this.$message.error(res.msg)


    },
    formatDateTime(date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      const hours = String(date.getHours()).padStart(2, '0')
      const minutes = String(date.getMinutes()).padStart(2, '0')
      return `${year}-${month}-${day} ${hours}:${minutes}`
    },
    logout() {
      this.$store.dispatch("logout");
      this.$message.success('已退出登录')
      this.showUserMenu = false
    },
    minimizeWindow() {
      this.$message.info('最小化功能需在Electron中使用')
    },
    closeWindow() {
      this.$message.info('关闭功能需在Electron中使用')
    }
  }
}
</script>

<style lang="scss">

.layout-container { display: flex; height: 100%; }
.sidebar {
    width: 220px;
    background: #141414;
    border-right: 1px solid #2a2a2a;
    transition: width 0.3s;
    display: flex;
    flex-direction: column;
    height: 100%;
    overflow: hidden;
}
.sidebar.collapsed { width: 64px; }




.logo {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 8px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 0 16px;
}
.logo-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: rgba(255, 255, 255, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    font-size: 18px;
    font-weight: bold;
    flex-shrink: 0;
}
.logo h2 { color: #fff; font-size: 20px; font-weight: 600; margin: 0; }
.menu-item {
    padding: 14px 20px;
    cursor: pointer;
    color: #b0b0b0;
    display: flex;
    align-items: center;
    gap: 12px;
    transition: all 0.3s;
  white-space: nowrap;
}
.menu-item:hover, .menu-item.active {
    background: #1a1a1a;
    color: #667eea;
}
.menu-item i { font-size: 18px; }
.expiry-info {
    margin-top: auto;
    padding: 16px;
    border-top: 1px solid #2a2a2a;
    display: flex;
    align-items: center;
    gap: 12px;

}
.expiry-icon {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}
.expiry-icon i {
    color: #fff;
    font-size: 16px;
}
.expiry-content {
    display: flex;
    flex-direction: column;
    gap: 2px;
    white-space: nowrap;
}
.expiry-label {
    color: #888;
    font-size: 12px;
}
.expiry-date {
    color: #e0e0e0;
    font-size: 14px;
    font-weight: 600;
}
.main-container { flex: 1; display: flex; flex-direction: column; }
.header {
    height: 60px;
    background: #141414;
    border-bottom: 1px solid #2a2a2a;
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 24px;
}
.header-right {
    display: flex;
    align-items: center;
    gap: 16px;
}
.window-btn {
    width: 36px;
    height: 36px;
    border-radius: 8px;
    background: #1a1a1a;
    border: 1px solid #2a2a2a;
    color: #888;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 16px;
    transition: all 0.3s;
}
.window-btn:hover {
    color: #e0e0e0;
    border-color: #667eea;
    background: #667eea;
}
.window-btn.close:hover {
    background: #e74c3c;
    border-color: #e74c3c;
}
.user-info-wrapper {
    display: flex;
    align-items: center;
    gap: 12px;
    position: relative;
}
.user-avatar {
    width: 44px;
    height: 44px;
    border-radius: 50%;
    background: linear-gradient(135deg, #667eea, #764ba2);
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 20px;
    color: #fff;
    font-weight: bold;
    cursor: pointer;
    transition: all 0.3s;
}
.user-avatar:hover {
    transform: scale(1.05);
}
.user-details {
    display: flex;
    flex-direction: column;
    gap: 2px;
}
.user-name {
    color: #e0e0e0;
    font-size: 15px;
    font-weight: 600;
}
.user-role {
    color: #888;
    font-size: 12px;
}
.user-dropdown {
    position: absolute;
    top: calc(100% + 8px);
    right: 0;
    background: #141414;
    border: 1px solid #2a2a2a;
    border-radius: 12px;
    padding: 8px 0;
    min-width: 200px;
    box-shadow: 0 8px 24px rgba(0,0,0,0.4);
    z-index: 1000;
}
.dropdown-item {
    padding: 12px 20px;
    display: flex;
    align-items: center;
    gap: 12px;
    color: #e0e0e0;
    cursor: pointer;
    transition: all 0.3s;
    font-size: 14px;
}
.dropdown-item:hover {
    background: #1a1a1a;
    color: #667eea;
}
.dropdown-divider {
    height: 1px;
    background: #2a2a2a;
    margin: 8px 0;
}
.header-left { display: flex; align-items: center; gap: 16px; }
.collapse-btn {
  cursor: pointer; color: #b0b0b0; font-size: 20px;
  transform: rotate(-180deg);
  display: inline-block;
  transition: .5s all;
  &.acitve{
    transform: rotate(0deg);
  }
}

.page-title { font-size: 18px; font-weight: 600; color: #e0e0e0; }
.main-content { flex: 1; padding: 24px; overflow-y: auto; }

/* 卡密充值弹窗样式 */
.recharge-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 16px 20px;
    margin: 0;
  }
  .el-dialog__title {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }
  .el-dialog__headerbtn {
    .el-dialog__close {
      color: #fff;
      font-size: 20px;
      &:hover {
        color: #fff;
        opacity: 0.8;
      }
    }
  }
}

.recharge-content {
  padding: 10px 0;
}

.recharge-info {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 12px;
}

.recharge-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.recharge-icon i {
  color: #fff;
  font-size: 24px;
}

.recharge-text {
  flex: 1;
}

.recharge-title {
  color: #e0e0e0;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

.recharge-desc {
  color: #888;
  font-size: 13px;
}

.dialog-footer {
  display: flex;
  justify-content: flex-end;
  gap: 12px;
}

/* 覆盖 Element UI Dialog 默认样式 */
.recharge-dialog {
  .el-dialog {
    background: #141414;
    border-radius: 12px;
    border: 1px solid #2a2a2a;
  }
  .el-dialog__body {
    padding: 20px;
    background: #141414;
  }
  .el-dialog__footer {
    padding: 16px 20px 20px;
    background: #141414;
    border-top: 1px solid #2a2a2a;
  }
  .el-button--default {
    background: #1a1a1a;
    border-color: #2a2a2a;
    color: #e0e0e0;
  }
  .el-button--default:hover {
    background: #2a2a2a;
    border-color: #3a3a3a;
    color: #e0e0e0;
  }
  .el-button--primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
  }
  .el-button--primary:hover {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  }
  .el-input__inner {
    border-color: #2a2a2a;
    background: #1a1a1a;
    color: #e0e0e0;
  }
  .el-input__inner::placeholder {
    color: #6b7280;
  }
  .el-input__inner:focus {
    border-color: #667eea;
  }
}

/* 弹窗遮罩层 */
.v-modal {
  background: rgba(0, 0, 0, 0.7);
}

/* 修改密码弹窗样式 */
.password-dialog {
  .el-dialog__header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    padding: 16px 20px;
    margin: 0;
  }
  .el-dialog__title {
    color: #fff;
    font-size: 16px;
    font-weight: 600;
  }
  .el-dialog__headerbtn {
    .el-dialog__close {
      color: #fff;
      font-size: 20px;
      &:hover {
        color: #fff;
        opacity: 0.8;
      }
    }
  }
}

.password-content {
  padding: 10px 0;
}

.password-info {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 20px;
  padding: 16px;
  background: linear-gradient(135deg, rgba(102, 126, 234, 0.1) 0%, rgba(118, 75, 162, 0.1) 100%);
  border-radius: 12px;
}

.password-icon {
  width: 48px;
  height: 48px;
  border-radius: 12px;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.password-icon i {
  color: #fff;
  font-size: 24px;
}

.password-text {
  flex: 1;
}

.password-title {
  color: #e0e0e0;
  font-size: 15px;
  font-weight: 600;
  margin-bottom: 4px;
}

.password-desc {
  color: #888;
  font-size: 13px;
}

/* 覆盖 Element UI Dialog 默认样式 - 密码弹窗 */
.password-dialog {
  .el-dialog {
    background: #141414;
    border-radius: 12px;
    border: 1px solid #2a2a2a;
  }
  .el-dialog__body {
    padding: 20px;
    background: #141414;
  }
  .el-dialog__footer {
    padding: 16px 20px 20px;
    background: #141414;
    border-top: 1px solid #2a2a2a;
  }
  .el-button--default {
    background: #1a1a1a;
    border-color: #2a2a2a;
    color: #e0e0e0;
  }
  .el-button--default:hover {
    background: #2a2a2a;
    border-color: #3a3a3a;
    color: #e0e0e0;
  }
  .el-button--primary {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    border: none;
  }
  .el-button--primary:hover {
    background: linear-gradient(135deg, #764ba2 0%, #667eea 100%);
  }
  .el-input__inner {
    border-color: #2a2a2a;
    background: #1a1a1a;
    color: #e0e0e0;
  }
  .el-input__inner::placeholder {
    color: #6b7280;
  }
  .el-input__inner:focus {
    border-color: #667eea;
  }
  .el-form-item__label {
    color: #888;
  }
}
</style>
